<template>
  <div class="relative flex justify-between w-full h-full">
    <div @click="$refs.remarks.openList()" class="relative cursor-pointer p-x-2 p-y-1 flex justify-center w-full items-center">
      <div v-if="!row.remarks" class="text-gray-text">Choose remark</div>
      <div v-else>
        <div v-if="row.remarks == 'own_remark'">
          <span v-if="row.remark_info" @click.stop="isRemarkModal = true">{{row.remark_info}}</span>
          <span v-else class="text-gray-text" @click.stop="isRemarkModal = true">Enter the Own Remark</span>
        </div>

        <div v-else-if="row.remarks == 'ntc_remark'">
          NTC
          (<span v-if="row.remark_info" @click.stop="isRemarkModal = true">{{row.remark_info}}</span>
          <span v-else class="text-gray-text" @click.stop="isRemarkModal = true">Enter the Own Remark</span>)
        </div>

        <div v-else>{{getNameById(row.remarks) === 'N/A' ? '' : getNameById(row.remarks)}}</div>
      </div>

      <div class="flex items-center position-absolute">
        <div class="m-r-2" v-if="row.remarks == 'ntc_remark' || row.remarks == 'own_remark'">
          <svg v-if="row.is_remark" @click.stop="row.is_remark = !row.is_remark" class="eye_show hover:fill-blue-dark cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="#9AA3B0" xmlns="http://www.w3.org/2000/svg"><path d="M7.64102 8.34104L7.91927 8.98336V8.98336L7.64102 8.34104ZM16.7374 8.34104L16.4591 8.98336L16.7374 8.34104ZM1.84187 12.4791C1.63878 12.808 1.74081 13.2393 2.06977 13.4424C2.39873 13.6455 2.83004 13.5435 3.03313 13.2145L1.84187 12.4791ZM3.70956 11.1571L4.22773 11.6278L3.70956 11.1571ZM20.6688 11.1571L21.187 10.6865L20.6688 11.1571ZM21.3452 13.2145C21.5483 13.5435 21.9796 13.6455 22.3086 13.4424C22.6376 13.2393 22.7396 12.808 22.5365 12.4791L21.3452 13.2145ZM7.91927 8.98336C9.22725 8.41675 10.6706 8.10234 12.1892 8.10234V6.70234C10.4756 6.70234 8.84313 7.05744 7.36277 7.69872L7.91927 8.98336ZM12.1892 8.10234C13.7078 8.10234 15.1511 8.41675 16.4591 8.98336L17.0156 7.69872C15.5352 7.05744 13.9028 6.70234 12.1892 6.70234V8.10234ZM3.03313 13.2145C3.38241 12.6488 3.78274 12.1177 4.22773 11.6278L3.1914 10.6865C2.68886 11.2398 2.2366 11.8397 1.84187 12.4791L3.03313 13.2145ZM20.1506 11.6278C20.5956 12.1177 20.996 12.6488 21.3452 13.2145L22.5365 12.4791C22.1418 11.8397 21.6895 11.2398 21.187 10.6865L20.1506 11.6278ZM17.1048 10.9121C17.1048 13.6326 14.8994 15.838 12.1789 15.838V17.238C15.6726 17.238 18.5048 14.4058 18.5048 10.9121H17.1048ZM12.1789 15.838C9.45839 15.838 7.25298 13.6326 7.25298 10.9121H5.85298C5.85298 14.4058 8.68519 17.238 12.1789 17.238V15.838ZM7.25298 10.9121C7.25298 10.1972 7.40481 9.51974 7.67731 8.90853L6.39864 8.33845C6.0477 9.12558 5.85298 9.99702 5.85298 10.9121H7.25298ZM4.22773 11.6278C5.11099 10.6553 6.16966 9.84557 7.35326 9.24846L6.72268 7.99852C5.38452 8.6736 4.1887 9.58849 3.1914 10.6865L4.22773 11.6278ZM7.35326 9.24846C7.53892 9.1548 7.72766 9.06637 7.91927 8.98336L7.36277 7.69872C7.14605 7.7926 6.93261 7.89261 6.72268 7.99852L7.35326 9.24846ZM16.6753 8.89686C16.9511 9.51112 17.1048 10.1927 17.1048 10.9121H18.5048C18.5048 9.99119 18.3076 9.11449 17.9525 8.32344L16.6753 8.89686ZM16.4591 8.98336C16.6422 9.06266 16.8226 9.14691 17.0002 9.23594L17.6275 7.98436C17.4267 7.88369 17.2226 7.78841 17.0156 7.69872L16.4591 8.98336ZM17.0002 9.23594C18.1939 9.83423 19.2612 10.6485 20.1506 11.6278L21.187 10.6865C20.1827 9.5808 18.9771 8.66078 17.6275 7.98436L17.0002 9.23594Z"/><path d="M14.2074 11.5783C14.2074 12.6809 13.3137 13.5746 12.2111 13.5746C11.1086 13.5746 10.2148 12.6809 10.2148 11.5783C10.2148 10.4758 11.1086 9.58203 12.2111 9.58203C13.3137 9.58203 14.2074 10.4758 14.2074 11.5783Z"/></svg>
          <svg v-else @click.stop="row.is_remark = !row.is_remark" class="eye_show hover:stroke-blue-dark cursor-pointer" width="24" height="24" viewBox="0 0 24 24" stroke="#9AA3B0" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.8346 13.6163V15.9365M11.8346 13.6163C13.2281 13.6163 14.5541 13.3277 15.7562 12.8069M11.8346 13.6163C10.4412 13.6163 9.1151 13.3277 7.91299 12.8069M20.243 8.92188C19.9222 9.44143 19.5546 9.92903 19.1461 10.3788M3.42628 8.92188C3.74704 9.44143 4.11461 9.92903 4.52311 10.3788M15.7562 12.8069L17.2504 14.9817M15.7562 12.8069C17.0545 12.2445 18.2082 11.4114 19.1461 10.3788M7.91299 12.8069L6.62822 14.9817M7.91299 12.8069C6.61474 12.2445 5.46104 11.4114 4.52311 10.3788M19.1461 10.3788L21.0696 11.9979M4.52311 10.3788L2.57031 11.9979" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>

        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.72248 4.39844C2.4552 4.39844 2.32135 4.72158 2.51034 4.91057L5.78609 8.18631C5.90325 8.30346 6.0932 8.30346 6.21035 8.18631L9.48608 4.91057C9.67507 4.72158 9.54122 4.39844 9.27395 4.39844H2.72248Z" fill="#2C2C2C"/></svg>
      </div>
    </div>
    <counterparties-drop
        :dontSelect="true"
        :active-item="{id: row.remarks,name: getNameById(row.remarks)}"
      class="hide_input w-full vessel_owners__select_currency"
      ref="remarks"
      :list="remarksList"
      @select="selectedRemark"
    ></counterparties-drop>

    <modal-slots :showMod="isRemarkModal" @close="isRemarkModal = false">
      <template v-slot:title>
        <h2 class="fz18 fw500">Edit Own Remark Text</h2>
      </template>

      <label class="block-input m-x-6 m-b-4 text-align-left">
        <p class="text-gray-text fz13 m-b-1">Own Remark</p>
        <input class="block-input_content" type="text" maxlength="2000" v-model="customRemark">
      </label>

      <template v-slot:bottomSecondButton>
        <button class="m-l-8 p-x-16 blue-button fz14 fw500" v-on:click="onChangeRemark">Save</button>
      </template>
    </modal-slots>
  </div>
</template>

<script>
import counterpartiesDrop from '@/components/counterparties/counterpartiesAdd/counterpartiesDrop';
import modalSlots from '@/components/modal/modal-slots'
import { mapState } from 'vuex';

export default {
  props: {
    row: Object
  },
  components: {
    counterpartiesDrop,
    modalSlots
  },
  data() {
    return {
      customRemark: '',
      isRemarkModal: false
    }
  },
  computed: {
    ...mapState({
      remarksList: state => state.lay.remarksList
    })
  },
  methods: {
    selectedRemark(item) {
      this.row.remarks = item.id
    },
    getNameById(id) {
      let type = this.remarksList.find(el=>{
        return el.id == id
      })
      return type ? type.name : ''
    },
    onChangeRemark() {
      this.row.remark_info = this.customRemark
      this.isRemarkModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .position-absolute {
    position: absolute;
    right: 12px;
  }
</style>